import { Typography } from 'antd';

import { FEMALE_LABEL, MALE_ID, MALE_LABEL } from '@app/constants';
import { formatDate } from '@app/utils';

import type { NUserPreview } from '@pages/Users/UserPreview/UserPreview.types';

const { Text } = Typography;

export const AdditionalInfo: NUserPreview.AdditionalInfo = ({ user }) => {
  return (
    <div className="additional-info-container">
      {user?.DateBirth && (
        <div className="record">
          <Text
            strong
            className="record-title"
            data-testid="full-date-of-birth"
          >
            Дата рождения:
          </Text>
          <Text className="record-content">
            {formatDate(user?.DateBirth.slice(0, 10))}
          </Text>
        </div>
      )}

      {user?.Gender && (
        <div className="record">
          <Text strong className="record-title">
            Пол:
          </Text>
          <Text className="record-content" data-testid="gender">
            {user.Gender === MALE_ID ? MALE_LABEL : FEMALE_LABEL}
          </Text>
        </div>
      )}

      {user?.DateWorkStart && (
        <div className="record">
          <Text strong className="record-title">
            Дата приёма на работу:
          </Text>
          <Text className="record-content">
            {formatDate(user.DateWorkStart.slice(0, 10))}
          </Text>
        </div>
      )}

      {user?.DatePatentEnd && (
        <div className="record">
          <Text strong className="record-title">
            Дата окончания регистрации/патента:
          </Text>
          <Text className="record-content">
            {formatDate(user.DatePatentEnd.slice(0, 10))}
          </Text>
        </div>
      )}

      {user?.Citizenship && (
        <div className="record">
          <Text strong className="record-title">
            Гражданство:
          </Text>
          <Text className="record-content">{user.Citizenship}</Text>
        </div>
      )}

      {user?.PassportInfo && (
        <div className="record">
          <Text strong className="record-title">
            Пасспортные данные:
          </Text>
          <Text className="record-content">{user.PassportInfo}</Text>
        </div>
      )}

      {user?.TaxPayerId && user?.TaxPayerId !== 0 && (
        <div className="record">
          <Text strong className="record-title">
            ИНН:
          </Text>
          <Text className="record-content">{user?.TaxPayerId}</Text>
        </div>
      )}

      {user?.InsuranceCertificateN && (
        <div className="record">
          <Text strong className="record-title">
            Номер страхового свидетельства:
          </Text>
          <Text className="record-content">{user.InsuranceCertificateN}</Text>
        </div>
      )}
    </div>
  );
};
